var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.105,
    height: 16.697,
    viewBox: "0 0 23.105 16.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-tick-2349168",
    transform: "translate(-21.4 -28.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9669",
    "data-name": "Path 9669",
    d: "M44.183,28.551a1.131,1.131,0,0,0-1.639,0L29.007,42.088,23.39,36.471a1.159,1.159,0,0,0-1.639,1.639l6.437,6.437a1.131,1.131,0,0,0,1.639,0L44.183,30.19a1.2,1.2,0,0,0,0-1.639Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusTick);
export default __webpack_public_path__ + "static/media/status_tick.cd19d45961d5b03bb98807383c1b62f8.svg";
export { ForwardRef as ReactComponent };